var Handlebars = require("/Users/taojie/work/node_project/test/previewer-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;

  return "<div id=\"login\" class=\" ui-widget ui-widget-content ui-corner-all\">\n    <label id=\"logo\">"
    + alias1(((helper = (helper = helpers.projectTitle || (depth0 != null ? depth0.projectTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"projectTitle","hash":{},"data":data}) : helper)))
    + "</label>\n    <label class=\"label\">"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.userName : stack1), depth0))
    + "</label>\n    <input class=\"ui-widget-content\" id=\"uid\" type=\"text\"/><br>\n    <label class=\"label\">"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.password : stack1), depth0))
    + "</label>\n    <input class=\"ui-widget-content\" id=\"pwd\" type=\"password\"/><br>\n    <div id=\"tips\" class=\"ui-corner-all\" ></div>\n    <button id=\"login-btn\">"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.login : stack1), depth0))
    + "</button>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/index.html
// module id = 5
// module chunks = 0